import React from "react";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import AccountMenuComponent from "../../../../lib/bandung/components/AccountMenu/AccountMenuComponent";

const MobileDrawer = ({ navItems, mobileOpen, handleDrawerToggle }) => {
  const list = () => (
    <Box sx={{ width: 250 }} role="presentation" className="bg-slate-700">
      <List>
        {navItems.map((navItem, index) => {
          console.log("navItems:", navItem.key);
          return (
            <ListItem key={index} disablePadding>
              <ListItemButton href={navItem.url}>
                <ListItemText primary={navItem.displayName} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
      <Divider />
      <Box pl={1} pr={1} pt={2}>
        <AccountMenuComponent />
      </Box>
    </Box>
  );
  return (
    <Drawer anchor="right" open={mobileOpen} onClose={handleDrawerToggle}>
      {list()}
    </Drawer>
  );
};

export default MobileDrawer;
